export const GET_FREEBET = 'GET_FREEBET';
export const SUCCESS_GET_FREEBET = 'SUCCESS_GET_FREEBET';
export const FAILURE_GET_FREEBET = 'FAILURE_GET_FREEBET';

export const TOGGLE_FREEBET = 'TOGGLE_FREEBET';



// WEBPACK FOOTER //
// ./js/actions/Freebet.js